/**
 * Wie Namen für den Vergleich mit dem Grundwissen aussehen.
 *
 * Gemeinsam genutzt von `guessCategory` und `guessStaple`: Beide vergleichen
 * deutsche Warennamen gegen eine Tabelle, und beide sind am 20.09.2026 über
 * dieselbe Falle gestolpert, die Akzente.
 */

/**
 * Akzente fallen für den Vergleich weg, Umlaute nicht.
 *
 * "Crème fraîche" blieb ohne Warengruppe, weil in der Tabelle "creme fraiche"
 * steht. Ä, Ö, Ü und ß stehen bewusst nicht in dieser Tabelle: Der Katalog ist
 * deutsch, und "Müsli" und "Musli" dürfen verschiedene Dinge sein.
 *
 * Eine Tabelle statt NFD-Zerlegung, weil die auch die Umlaute zerlegen würde
 * und der Weg zurück dann ein Sonderzeichen als Merkzeichen bräuchte.
 */
const AKZENTE: Readonly<Record<string, string>> = {
  à: "a", á: "a", â: "a", ã: "a", å: "a", ā: "a",
  è: "e", é: "e", ê: "e", ë: "e", ē: "e",
  ì: "i", í: "i", î: "i", ï: "i", ī: "i",
  ò: "o", ó: "o", ô: "o", õ: "o", ō: "o",
  ù: "u", ú: "u", û: "u", ū: "u",
  ç: "c", ñ: "n", ý: "y", ÿ: "y", š: "s", ž: "z", æ: "ae", œ: "oe",
};

/** Genau die Zeichen aus der Tabelle, keines mehr. */
const AKZENT_MUSTER = new RegExp(`[${Object.keys(AKZENTE).join("")}]`, "gu");

export function ohneAkzente(wert: string): string {
  // Bindestriche trennen wie Leerzeichen: "Sweet-Chili-Sauce" soll dasselbe
  // treffen wie "Sweet Chili Sauce", sonst gewinnt das bloße "Chili".
  return wert.replace(/-/gu, " ").replace(AKZENT_MUSTER, (zeichen) => AKZENTE[zeichen] ?? zeichen);
}
